import 'reflect-metadata';

if (typeof (globalThis as any).window !== 'undefined') {
  throw new Error(
    'HelioSDK is not supported in the browser, please run it in node environment',
  );
}

export { HelioSDK } from './HelioSDK';
export { HelioSDKError } from './Error';
